import React, { useState } from "react";

import { Box, Grid, Tab, Tabs } from "@mui/material";

import TabPanel from "../components/shared/tab-panel";
import mainStyles from "../styles";
import GenerateAttributes from "components/marketplace/generate-attributes";
import MarketplaceAttributes from "components/marketplace/marketplace-attributes";
import MarketplaceJobs from "components/marketplace/marketplace-jobs";
import MarketplaceAttributeGroups from "components/marketplace/marketplace-profile";

const Marketplace = () => {
  const classes = mainStyles();
  const [tabValue, setTabValue] = useState(0);

  const handleTabChange = (
    event: React.ChangeEvent<unknown>,
    newValue: number
  ) => {
    setTabValue(newValue);
  };

  const tabs = [
    {
      label: "Jobs",
      component: (
        <Box marginTop={2}>
          <MarketplaceJobs />
        </Box>
      ),
      enabled: true,
    },
    {
      label: "Extract Attributes",
      component: (
        <Box marginTop={2}>
          <MarketplaceAttributes />
        </Box>
      ),
      enabled: true,
    },
    {
      label: "Generate Attributes",
      component: (
        <Box marginTop={2}>
          <GenerateAttributes />
        </Box>
      ),
      enabled: true,
    },
    {
      label: "Extract Attribute Groups",
      component: (
        <Box marginTop={2}>
          <MarketplaceAttributeGroups />
        </Box>
      ),
      enabled: true,
    },
  ];

  return (
    <Grid container sx={classes.basicSpacing} spacing={1}>
      <Grid item xs={12}>
        <Tabs
          value={tabValue}
          onChange={handleTabChange}
          indicatorColor="primary"
          textColor="primary"
        >
          {tabs.map((tab) => {
            if (tab.enabled) {
              return (
                <Tab
                  label={tab.label}
                  key={tab.label}
                  data-testid="tab-option"
                />
              );
            }
            return undefined;
          })}
        </Tabs>
        {tabs.map((tab, index) => {
          return (
            <div key={tab.label}>
              <TabPanel value={tabValue} index={index}>
                {tab.component}
              </TabPanel>
            </div>
          );
        })}
      </Grid>
    </Grid>
  );
};

export default Marketplace;
